import React from "react";

export function PresenceAvatars({ peers = [], selfInfo }) {
  const all = [];
  if (selfInfo) all.push({ ...selfInfo, self: true });
  peers.forEach((p) => all.push(p));
  const unique = Array.from(new Map(all.map((u) => [u.id, u])).values()).slice(0, 5);

  return (
    <div className="flex -space-x-2" data-testid="presence-avatars">
      {unique.map((u) => (
        <div key={u.id}
          className="w-7 h-7 rounded-full border-2 border-[#0F0F10] flex items-center justify-center text-[10px] font-medium"
          style={{ background: u.color || "#27272A", color: "#0A0A0A" }}
          title={`${u.name}${u.self ? " (you)" : ""}`}
          data-testid={`presence-${u.id}`}>
          {u.name?.[0]?.toUpperCase()}
        </div>
      ))}
      {peers.length > 4 && (
        <div className="w-7 h-7 rounded-full bg-[#141414] border-2 border-[#0F0F10] flex items-center justify-center text-[10px] text-[#A1A1AA]">
          +{peers.length - 4}
        </div>
      )}
    </div>
  );
}
